import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_ATTENDANCE_HISTORY_REQUEST = 'FETCH_ATTENDANCE_HISTORY_REQUEST';
export const FETCH_ATTENDANCE_HISTORY_SUCCESS = 'FETCH_ATTENDANCE_HISTORY_SUCCESS';
export const FETCH_ATTENDANCE_HISTORY_FAILURE = 'FETCH_ATTENDANCE_HISTORY_FAILURE';

export function fetchAttendanceHistory(filterParams) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildUrl(`/attendance/groups/${filterParams.groupId}/histories
?pageSize=${filterParams.pageSize}&pageNumber=${filterParams.pageNumber}`);

    return dispatch(fetchAttendanceHistoryRequest()).payload
      .then((response) => dispatch(fetchAttendanceHistorySuccess(response)))
      .catch((error) => dispatch(fetchAttendanceHistoryFailure(error)));

    function fetchAttendanceHistoryRequest() {
      return ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchAttendanceHistorySuccess(response) {
      return ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function fetchAttendanceHistoryFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/AttendanceHistory/actions.js